import '../CsvJsonInfoPages.scss';


function Prices() {

    const data = [
        { field: 1, description: 'CAP ID (Int)' },
        { field: 2, description: 'Date Model Year is Effective From (Date)' },
        { field: 3, description: 'Date Model Year is Effective To (Blank if still current) (Date)' },
        { field: 4, description: 'Reference Description (String)' },
        { field: 5, description: 'Image ID (Int)' },
        { field: 6, description: 'Not An Exact Match (Bit)' },
    ];



    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Prices</h1>
            <p>This file contains the new prices of a vehicle. It is a complete history from 1998, so will contain both current and non-current vehicles. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_NVDPrices.txt<br />
                LIGHTS_yyyy-mm-dd_NVDPrices.txt<br />
                HEAVIES_yyyy-mm-dd_NVDPrices.txt<br />
                BIKES_yyyy-mm-dd_NVDPrices.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p>Notes: <br />
                Dates are outputted in Universal Date Format (yyyy/mm/dd) E.g. A date of 2003/07/01 would represent 1st July 2003.
            </p>
        </div>
    );
}

export default Prices;
